import { useStaticQuery, graphql } from "gatsby"

const YoutubeRecentJA = () => {
  const { allYoutubeVideo } = useStaticQuery(graphql`
    query {
      allYoutubeVideo(
          limit: 9,
          filter: {channelId: {eq: "UCoxOKSbRGkZSNR7no2-7U9g"}}) {
        nodes {
          channelId
          id
          title
          description
          videoId
          publishedAt
          privacyStatus
          channelTitle
          localThumbnail {
            childImageSharp {
              fluid (maxWidth: 320){
                ...GatsbyImageSharpFluid 
              }
            }
          }
        }
      }
    }
  `)

  return allYoutubeVideo.nodes
}

export default YoutubeRecentJA
